module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71616158a7b62bb987ae9db090226254.png";